export default {
  default: () => import("/home/circleci/wineaccess/nuxt-app/client/wineaccess/layouts/default.vue")
}